import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { createStl, CreateStlRequest, CreateStlResponse } from 'src/api/bookingService';

// No retries: this creates a reservation, so retrying a timed out request could create a duplicate
export const useCreateStl = () =>
    useMutation<CreateStlResponse, AxiosError, CreateStlRequest>({
        mutationKey: ['createStl'],
        mutationFn: (stlDetails) => createStl(stlDetails),
    });
